/* eslint-disable */
export enum FlagReason {
    // constant members
    None = 0,
    Offensive  = 1 << 1,
    Fraud      = 1 << 2,
    Abuse      = 1 << 3,
    Malware    = 1 << 4,
    Copyright  = 1 << 5,
    Pornographic  = 1 << 6,
    SPAM  = 1 << 7,
    HateSpeech  = 1 << 8
}
